import React from "react";
import "./PaymentReceipt.css";
import { useAuth } from "../../Store/AuthContext";
import ShowImagePath from "../Others/ImportantFunction";

const PaymentReceipt = () => {
  const { webSetting } = useAuth();
  const ImageShowimage = ShowImagePath(
    webSetting.file_path,
    webSetting.header_logo
  );

  return (
    <div className="receiptbody">
      <div className="receipt-container">
        <div className="receiptheader">
          <img
            src={webSetting.header_logo && ImageShowimage}
            alt="Logo"
            className="logo"
          />
        </div>
        <div className="headerSummerybox">
          <div className="Headersummaryrow">
            <span className="mainsidetile">Receipt No.</span>
            <span className="maintitle">HYP-001</span>
          </div>
          <div className="Headersummaryrow">
            <span className="mainsidetile">Transaction Date.</span>
            <span className="maintitle">05 Jun 2025</span>
          </div>
        </div>
        <div className="receipt-details row">
          <div className="detail-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3 className="mainH3HEading">Payment Information</h3>
            <div className="detail-row">
              <span className="detail-label">Order ID. :</span>
              <span className="detail-value">skdfgk7s58</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Payment Method:</span>
              <span className="detail-value">Credit Card (VISA ****4532)</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Status:</span>
              <span className="detail-value">
                <span className="status-success">Completed</span>
              </span>
            </div>
          </div>

          <div className="detail-section col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3 className="mainH3HEading">Customer Information</h3>
            <div className="detail-row">
              <span className="detail-label">Name:</span>
              <span className="detail-value">John Doe</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Email:</span>
              <span className="detail-value">john.doe@example.com</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Phone:</span>
              <span className="detail-value">+1 (555) 123-4567</span>
            </div>
          </div>
        </div>

        <div className="payment-summary">
          <h3>Payment Summary</h3>
          <div className="summary-row">
            <span className="summeryFtitle">Lead Amount:</span>
            <span className="summeryAmtitle">$25.00</span>
          </div>
          <div className="summary-row">
            <span className="summeryFtitle text-danger">Discount:</span>
            <span className="summeryAmtitle text-danger">$25.00</span>
          </div>

          <div className="summary-row">
            <span>Total Amount Paid:</span>
            <span>$29.25</span>
          </div>
        </div>

        <div className="action-buttons">
          <button className="btn btn-primary" onClick={() => window.print()}>
            Print Receipt
          </button>{" "}
          <button
            className="btn
        btn-secondary"
          >
            Download PDF
          </button>{" "}
        </div>

        <div className="footer">
          <p className="mb-0">Thank you for using YourDoorstep Services.</p>
          <p>
            For any questions regarding this payment, please contact our support
            team at <strong>support@yourdoorstep.co</strong> or call{" "}
            <strong>+91 9540005064</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentReceipt;
